import { allNotificationRules } from '../queries';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';

export function useAllNotificationRules () {
  const { data: query , refetch: refresh, loading: isLoading } = useQuery(allNotificationRules, {
    fetchPolicy: 'no-cache',
  });
  const rawData = (query?.allNotificationRules?.edges.length) > 0 ? removeConnectionsMemoized(query?.allNotificationRules) : [];
  const data = rawData.filter(row => row.enabled).map(row => ({
		sent: row.lastSent,
		name: row.name,
		trigger: row?.trigger?.name || '-',
		portfolio: row.lastPortfolio,
    npoProgram: row.lastNpo,
    year: row.lastPortfolioYear,
    program: row.lastProgram,
    programPhoto: row.lastProgramPhoto,
    resourceStatus: row.resourceStatus,
		delivery: row.deliveryImmediate ? 'Immediate' : 'Digest',
		recipients: row.recipients.reduce((acc, item) => { return acc + item.fullName + ' '; }, ''),
    history: [],
    data: row,
    donorDefault: row?.donorDefault,
    template: row?.getTemplate ?? null
  }));
  return {
    data,
    refresh,
    isLoading
  };
}
